import React from "react";
import { Link } from "react-router-dom";
import { roleHead } from "./rolesdata";

const Roles = () => {
  return (
    <>
      <section className="rolesSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading">
                <h3 data-aos="slide-down">
                  Our <span>Roles</span>
                </h3>
                <p data-aos="slide-down">
                  we will help you find the right fit for you
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            {roleHead.map((m) => (
              <div
                className="col-lg-3 col-md-6 mb-4 mb-lg-0"
                data-aos="zoom-in"
                key={m.id}
              >
                <div className="roleSpecialist">
                  <div className="head">
                    {/* <img src={m.images} alt="Hire Web Application Developers" /> */}
                    <h5>{m.label}</h5>
                  </div>
                  <ul>
                    {m.subData.map((s) => (
                      <li key={s}>
                        <span>{s}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
            <div className="col-md-12 mt-5" data-aos="slide-down">
              <Link to="/HireDeveloper" className="btn">
                <span>Hire Top Developers</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Roles;
